module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "userInfo"
    }
  }, [(_vm.showCompletion) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "well well-sm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('p', [_vm._v("\n                            We have detected that this may be the first time you have logged into the system.Please take a moment to provide us with your details\n                            (personal details, address details, contact details, and whether you are managing licences for an organisation).\n                            Once completed, click Continue to start using the system.\n                        ")]), _vm._v(" "), (_vm.completedProfile) ? _c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.userProfileCompleted()
      }
    }
  }, [_vm._v("Continue")]) : _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Complete profile to continue")])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Personal Details "), _c('small', [_vm._v("Provide your personal details")]), _vm._v(" "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.pBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.pBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "personal_form",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('b', [_vm._v("To update your account name please "), _c('a', {
    attrs: {
      "href": _vm.current_user.sso_setting_url + '/sso/setting?back=' + _vm.current_url
    }
  }, [_vm._v("click here")]), _vm._v(":")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Account Given name(s)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_user.first_name),
      expression: "current_user.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "first_name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.current_user.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.current_user, "first_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Account Surname")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_user.last_name),
      expression: "current_user.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "last_name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.current_user.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.current_user, "last_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Date of Birth")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    ref: "dob",
    staticClass: "input-group date",
    staticStyle: {
      "width": "100%"
    }
  }, [(!_vm.canUpdateDOB) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_user.legal_dob),
      expression: "current_user.legal_dob"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "dob",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.current_user.legal_dob)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.current_user, "legal_dob", $event.target.value)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_user.dob),
      expression: "current_user.dob"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "dob",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.current_user.dob)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.current_user, "dob", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Verified Given name(s)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_user.legal_first_name),
      expression: "current_user.legal_first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "legal_first_name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.current_user.legal_first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.current_user, "legal_first_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Verified Surname")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_user.legal_last_name),
      expression: "current_user.legal_last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "legal_last_name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.current_user.legal_last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.current_user, "legal_last_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.canUpdateDOB) ? _c('div', {
    staticClass: "col-sm-12"
  }, [(!_vm.updatingPersonal) ? _c('button', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updatePersonal()
      }
    }
  }, [_vm._v("Update")]) : _c('button', {
    staticClass: "pull-right btn btn-primary",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Updating")])]) : _vm._e()])])])])])]), _vm._v(" "), (!_vm.approvedExternalUser) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [(_vm.showCompletion && _vm.uploadedID) ? _c('i', {
    staticClass: "fa fa-check fa-2x pull-left",
    staticStyle: {
      "color": "green"
    }
  }) : (!_vm.uploadedID && !_vm.current_user.has_complete_first_time) ? _c('i', {
    staticClass: "fa fa-times fa-2x pull-left",
    staticStyle: {
      "color": "red"
    }
  }) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Identification "), _c('small', [_vm._v("Upload your photo ID")]), _vm._v(" "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.idBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "false",
      "aria-controls": _vm.idBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse",
    attrs: {
      "id": _vm.idBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "id_form",
      "method": "post"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v("Identification")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [(_vm.uploadedID) ? _c('span', {
    staticClass: "col-sm-3 btn btn-link btn-file pull-left"
  }, [_c('SecureBaseLink', {
    attrs: {
      "link_name": "Uploaded Photo ID",
      "link_data": {
        'user_id': _vm.current_user.id
      }
    }
  })], 1) : (!_vm.uploadedID) ? _c('span', {
    staticClass: "col-sm-3 btn btn-link btn-file pull-left"
  }, [_vm._v("Attach Photo ID"), _c('input', {
    ref: "uploadedID",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.readFileID()
      }
    }
  })]) : _c('span', {
    staticClass: "col-sm-3 btn btn-link btn-file pull-left"
  }, [_vm._v(" Uploading...")]), _vm._v(" "), (_vm.uploadedID) ? _c('span', {
    staticClass: "btn btn-link btn-file pull-left"
  }, [_c('a', {
    staticClass: "fa fa-trash-o",
    staticStyle: {
      "cursor": "pointer",
      "color": "red"
    },
    attrs: {
      "title": "Remove file"
    },
    on: {
      "click": function($event) {
        return _vm.removeID()
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [(_vm.showCompletion && _vm.current_user.address_details) ? _c('i', {
    staticClass: "fa fa-check fa-2x pull-left",
    staticStyle: {
      "color": "green"
    }
  }) : (_vm.showCompletion && !_vm.current_user.address_details) ? _c('i', {
    staticClass: "fa fa-times fa-2x pull-left",
    staticStyle: {
      "color": "red"
    }
  }) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Address Details "), _c('small', [_vm._v("Provide your address details")]), _vm._v(" "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.adBody,
      "data-toggle": "collapse",
      "expanded": "false",
      "data-parent": "#userInfo",
      "aria-controls": _vm.adBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), (_vm.loading.length == 0) ? _c('div', {
    staticClass: "panel-body collapse",
    attrs: {
      "id": _vm.adBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "index.html",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Street")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_user.residential_address.line1),
      expression: "current_user.residential_address.line1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "street",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.current_user.residential_address.line1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.current_user.residential_address, "line1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Town/Suburb")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_user.residential_address.locality),
      expression: "current_user.residential_address.locality"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "surburb",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.current_user.residential_address.locality)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.current_user.residential_address, "locality", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_user.residential_address.state),
      expression: "current_user.residential_address.state"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "country",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.current_user.residential_address.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.current_user.residential_address, "state", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Postcode")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_user.residential_address.postcode),
      expression: "current_user.residential_address.postcode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "postcode",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.current_user.residential_address.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.current_user.residential_address, "postcode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_user.residential_address.country),
      expression: "current_user.residential_address.country"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "country"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.current_user.residential_address, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.countries), function(c) {
    return _c('option', {
      key: c.code,
      domProps: {
        "value": c.code
      }
    }, [_vm._v(_vm._s(c.name))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(!_vm.updatingAddress) ? _c('button', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateAddress()
      }
    }
  }, [_vm._v("Update")]) : _c('button', {
    staticClass: "pull-right btn btn-primary",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Updating")])])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [(_vm.showCompletion && _vm.current_user.contact_details) ? _c('i', {
    staticClass: "fa fa-check fa-2x pull-left",
    staticStyle: {
      "color": "green"
    }
  }) : (_vm.showCompletion && !_vm.current_user.contact_details) ? _c('i', {
    staticClass: "fa fa-times fa-2x pull-left",
    staticStyle: {
      "color": "red"
    }
  }) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Contact Details "), _c('small', [_vm._v("Provide your contact details")]), _vm._v(" "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.cBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "false",
      "aria-controls": _vm.cBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse",
    attrs: {
      "id": _vm.cBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "index.html",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_user.phone_number),
      expression: "current_user.phone_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "phone",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.current_user.phone_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.current_user, "phone_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Mobile")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_user.mobile_number),
      expression: "current_user.mobile_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "mobile",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.current_user.mobile_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.current_user, "mobile_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_user.email),
      expression: "current_user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "email",
      "name": "email",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.current_user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.current_user, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(!_vm.updatingContact) ? _c('button', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateContact()
      }
    }
  }, [_vm._v("Update")]) : _c('button', {
    staticClass: "pull-right btn btn-primary",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Updating")])])])])])])])]), _vm._v(" "), (!_vm.approvedExternalUser) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Organisations "), _c('small', [_vm._v("Link to the Organisations you are an employee of and for which you are managing licences")]), _vm._v(" "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.oBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.oBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse",
    attrs: {
      "id": _vm.oBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "orgForm",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Do you manage licences on behalf of an organisation?")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.managesOrg),
      expression: "managesOrg"
    }],
    attrs: {
      "disabled": _vm.hasOrgs,
      "type": "radio",
      "name": "behalf_of_org",
      "value": "No"
    },
    domProps: {
      "checked": _vm._q(_vm.managesOrg, "No")
    },
    on: {
      "change": function($event) {
        _vm.managesOrg = "No"
      }
    }
  }), _vm._v(" No\n                            ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.managesOrg),
      expression: "managesOrg"
    }],
    attrs: {
      "type": "radio",
      "name": "behalf_of_org",
      "value": "Yes"
    },
    domProps: {
      "checked": _vm._q(_vm.managesOrg, "Yes")
    },
    on: {
      "change": function($event) {
        _vm.managesOrg = "Yes"
      }
    }
  }), _vm._v(" Yes\n                            ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.managesOrg),
      expression: "managesOrg"
    }],
    attrs: {
      "type": "radio",
      "name": "behalf_of_org",
      "value": "Consultant"
    },
    domProps: {
      "checked": _vm._q(_vm.managesOrg, "Consultant")
    },
    on: {
      "change": function($event) {
        _vm.managesOrg = "Consultant"
      }
    }
  }), _vm._v(" Yes, as a consultant\n                            ")])]), _vm._v(" "), (_vm.managesOrg == 'Yes') ? _c('div', [_c('div', {
    staticClass: "col-sm-3"
  }, [(_vm.hasOrgs && !_vm.addingCompany) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addCompany()
      }
    }
  }, [_vm._v("Add Another Organisation")]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.current_user.wildlifecompliance_organisations), function(org) {
    return _c('div', {
      key: org.id
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-2 control-label",
      attrs: {
        "for": ""
      }
    }, [_vm._v("Organisation")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (org.name),
        expression: "org.name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "disabled": "",
        "name": "organisation",
        "placeholder": ""
      },
      domProps: {
        "value": (org.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(org, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('label', {
      staticClass: "col-sm-1 control-label",
      attrs: {
        "for": ""
      }
    }, [_vm._v("ABN/ACN")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (org.abn),
        expression: "org.abn"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "disabled": "",
        "name": "organisation",
        "placeholder": ""
      },
      domProps: {
        "value": (org.abn)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(org, "abn", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.unlinkUser(org)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-chain-broken fa-2x"
    }), _vm._v(" Unlink")])])])
  }), _vm._v(" "), _vm._l((_vm.orgRequest_pending), function(orgReq) {
    return _c('div', {
      key: orgReq.id
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-2 control-label",
      attrs: {
        "for": ""
      }
    }, [_vm._v("Organisation")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (orgReq.name),
        expression: "orgReq.name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "disabled": "",
        "name": "organisation",
        "placeholder": ""
      },
      domProps: {
        "value": (orgReq.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(orgReq, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('label', {
      staticClass: "col-sm-1 control-label",
      attrs: {
        "for": ""
      }
    }, [_vm._v("ABN/ACN")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (orgReq.abn),
        expression: "orgReq.abn"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "disabled": "",
        "name": "organisation",
        "placeholder": ""
      },
      domProps: {
        "value": (orgReq.abn)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(orgReq, "abn", $event.target.value)
        }
      }
    })]), _vm._v(" "), _vm._m(5, true)])])
  }), _vm._v(" "), _vm._l((_vm.orgRequest_amendment_requested), function(orgReq) {
    return _c('div', {
      key: orgReq.id
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-2 control-label",
      attrs: {
        "for": ""
      }
    }, [_vm._v("Organisation")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (orgReq.name),
        expression: "orgReq.name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "disabled": "",
        "name": "organisation",
        "placeholder": ""
      },
      domProps: {
        "value": (orgReq.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(orgReq, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('label', {
      staticClass: "col-sm-1 control-label",
      attrs: {
        "for": ""
      }
    }, [_vm._v("ABN/ACN")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (orgReq.abn),
        expression: "orgReq.abn"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "disabled": "",
        "name": "organisation",
        "placeholder": ""
      },
      domProps: {
        "value": (orgReq.abn)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(orgReq, "abn", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "btn btn-info btn-file pull-left"
    }, [_vm._v("\n                                    Upload New File "), _c('input', {
      ref: "uploadedFile",
      refInFor: true,
      attrs: {
        "type": "file"
      },
      on: {
        "change": function($event) {
          return _vm.uploadNewFileUpdateOrgRequest(orgReq)
        }
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "pull-left",
      staticStyle: {
        "margin-left": "10px",
        "margin-top": "10px"
      }
    }, [_vm._v(_vm._s(_vm.uploadedFileName))])])])
  }), _vm._v(" "), (_vm.managesOrg == 'Consultant' && _vm.addingCompany) ? _c('div', [_c('h3', [_vm._v("New Organisation (as consultant)")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Organisation")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOrg.name),
      expression: "newOrg.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "organisation",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.newOrg.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newOrg, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("ABN/ACN")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOrg.abn),
      expression: "newOrg.abn"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "abn",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.newOrg.abn)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newOrg, "abn", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [(_vm.newOrg.detailsChecked) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.checkOrganisation()
      }
    }
  }, [_vm._v("Check Details")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-12",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n                                  Please upload a letter with an organisation letterhead stating that you are a consultant for the organisation.\n                                    "), _c('span', {
    staticClass: "btn btn-info btn-file"
  }, [_vm._v("\n                                        Atttach File "), _c('input', {
    ref: "uploadedFile",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.readFile()
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "10px",
      "margin-top": "10px"
    }
  }, [_vm._v(_vm._s(_vm.uploadedFileName))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10 control-label",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "for": ""
    }
  }, [_vm._v("You will be notified by email once the Department has checked the organisation details.\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [(!_vm.registeringOrg) ? _c('button', {
    staticClass: "btn btn-primary pull-left",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.orgConsultRequest()
      }
    }
  }, [_vm._v("Submit")]) : _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Submitting")])])])]) : _vm._e(), _vm._v(" "), (_vm.managesOrg == 'Yes' && _vm.addingCompany) ? _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('h3', [_vm._v("New Organisation")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Organisation")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOrg.name),
      expression: "newOrg.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "organisation",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.newOrg.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newOrg, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("ABN/ACN")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOrg.abn),
      expression: "newOrg.abn"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "abn",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.newOrg.abn)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newOrg, "abn", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.checkOrganisation()
      }
    }
  }, [_vm._v("Check Details")])])]), _vm._v(" "), (_vm.newOrg.exists && _vm.newOrg.detailsChecked) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-12",
    staticStyle: {
      "text-align": "left",
      "margin-bottom": "20px"
    }
  }, [_vm._v("\n                                This organisation has already been registered with the system. Please enter the two pin codes below."), _c('br'), _vm._v("\n                                These pin codes can be retrieved from one of the following people:"), _c('br'), _vm._v(" " + _vm._s(_vm.newOrg.first_five) + "\n                              ")]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Pin 1")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOrg.pin1),
      expression: "newOrg.pin1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "abn",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.newOrg.pin1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newOrg, "pin1", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Pin 2")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOrg.pin2),
      expression: "newOrg.pin2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "abn",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.newOrg.pin2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newOrg, "pin2", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [(!_vm.validatingPins) ? _c('button', {
    staticClass: "btn btn-primary pull-left",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.validatePins()
      }
    }
  }, [_vm._v("Validate")]) : _c('button', {
    staticClass: "btn btn-primary pull-left"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Validating Pins")])])]) : (!_vm.newOrg.exists && _vm.newOrg.detailsChecked) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('span', {
    staticClass: "btn btn-info btn-file pull-left"
  }, [_vm._v("\n                                    Attach File "), _c('input', {
    ref: "uploadedFile",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.readFile()
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-left": "10px",
      "margin-top": "10px"
    }
  }, [_vm._v(_vm._s(_vm.uploadedFileName))])]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10 control-label",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "for": ""
    }
  }, [_vm._v("You will be notified by email once the Department has checked the organisation details.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [(!_vm.registeringOrg) ? _c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.orgRequest()
      }
    }
  }, [_vm._v("Submit")]) : _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Submitting")])])]) : (_vm.newOrg.exists && !_vm.newOrg.detailsChecked) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('span', {
    staticClass: "btn btn-info btn-file pull-left"
  }, [_vm._v("\n                                    Attach File "), _c('input', {
    ref: "uploadedFile",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.readFile()
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-left": "10px",
      "margin-top": "10px"
    }
  }, [_vm._v(_vm._s(_vm.uploadedFileName))])]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10 control-label",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "for": ""
    }
  }, [_vm._v("You will be notified by email once the Department has checked the organisation details.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [(!_vm.registeringOrg) ? _c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.orgRequest()
      }
    }
  }, [_vm._v("Submit")]) : _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Submitting")])])]) : _vm._e()]) : _vm._e()], 2)])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('i', [_vm._v("Changes will not update until your next login.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('span', {
    staticClass: "col-sm-12"
  }, [_vm._v("     Attach a scan of the complete photo page of your passport or the complete photo side of your driver’s licence showing full name, date of birth and photo.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('i', {
    staticClass: "fa fa-hourglass-o fa-2x"
  }), _vm._v(" Pending Approval")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-sm-12",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n                                This organisation has not yet been registered with this system. Please upload a letter with an organisation letterhead stating that you are an employee of this organisation."), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-sm-12",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n                                Please upload a letter with an organisation letterhead stating that you are an employee of this organisation."), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f0988cd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/manage_my_user_details.vue
// module id = 934
// module chunks = 0